(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/physical-info.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/physical-info.js');
"use strict";

const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const Icon = svs.ui.ReactIcon;
setGlobal('svs.ticketsValidateManual.pages.home.components.PhysicalInfo', () => React.createElement(GridRow, {
  className: "u-flex-justify-content-center",
  gutter: 0
}, React.createElement(GridCol, {
  md: 8,
  sm: 12
}, React.createElement(Icon, {
  icon: "help-2"
}), React.createElement("br", null), React.createElement("span", {
  className: "f-medium f-italic"
}, "Psst! Vill du inte r\xE4tta din lott sj\xE4lv?"), React.createElement("br", null), React.createElement("span", {
  className: "f-italic"
}, "D\xE5 kan du precis som vanligt g\xE5 till en butik som s\xE4ljer Triss och f\xE5 den r\xE4ttad."))));

 })(window);